var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 19.0007L31.3179 17.0038C33.0505 16.6573 34.667 17.9825 34.667 19.7494V34.2519C34.667 36.0188 33.0505 37.344 31.3179 36.9975L21.3337 35.0007",
    stroke: "url(#paint0_linear_4461_22648)",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 27H21.3335",
    stroke: "url(#paint1_linear_4461_22648)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 31L26.5781 28.0667C27.2892 27.5333 27.2892 26.4667 26.5781 25.9333L22.667 23",
    stroke: "url(#paint2_linear_4461_22648)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4461_22648",
    x1: 28.0003,
    y1: 16.334,
    x2: 28.0003,
    y2: 37.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3C0E",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4461_22648",
    x1: 17.3335,
    y1: 27,
    x2: 17.3335,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3C0E",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4461_22648",
    x1: 24.8892,
    y1: 23,
    x2: 24.8892,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3C0E",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.8b1b7d58378e5d462ec63d1d7265fd87.svg";
export { ForwardRef as ReactComponent };